import { RootState } from '../../store/types';

export const selectHomeActiveTab = (state: RootState) => state.home.activeTab;
